import { Outlet, createFileRoute } from "@tanstack/react-router";

import { ClusterTabs, type ClusterTab } from "@/components/console/cluster-tabs";

// KRA connection: three tabs of one object — Health · Credentials · Call log. They are
// only ever read together (migration playbook, Operations section).
const KRA_CONNECTION_TABS: ClusterTab[] = [
  { label: "Health", to: "/ops/kra-connection/endpoints" },
  { label: "Credentials", to: "/ops/kra-connection/credentials" },
  { label: "Call log", to: "/ops/kra-connection/audit" },
];

export const Route = createFileRoute("/(app)/ops/kra-connection")({
  component: () => (
    <div className="flex w-full flex-col gap-3">
      <ClusterTabs items={KRA_CONNECTION_TABS} />
      <Outlet />
    </div>
  ),
});
